<template>
  <Modal>
    <div class="container">
      <h4>Are you sure you want to logout?</h4>
   <div class="container__buttons">
     <button
      class="button__logout"
      @click="logout"
     >Logout</button>
     <button
      class="button__cancel"
      @click="cancel"
    >Cancel</button>
   </div>
    </div>
  </Modal>

</template>
<script>
import Modal from '../general/Modal';
import ls from 'local-storage';
import VueNotifications from 'vue-notifications'
import store from '../../store';
export default {
  name: 'LogoutModal',
  components: {
    Modal
  },
  methods: {
    logout() {
      store.commit('hideModals', true);
      ls.set('GEG__KEY', '');
      this.$router.push('/');
      this.showSuccessMsg({ message: 'You\'ve been logged out.' })
    },
    cancel() {
      store.commit('hideModals', true);
    }
  },
  data() {
    return {
      userId: null,
      stage: null
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: 'ℹ️',
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  height: 100%;
}
h4 {
  font-size: 1.4rem;
  color: #525252;
  text-align: center;
  margin: 40px auto 20px;
}

.container__buttons {
  margin: 20px auto 40px;
  display: flex;
  flex-flow: row nowrap;
  max-width: 300px;
  width: 100%;
  justify-content: space-around;

  @media all and (max-width: 640px) {
    flex-flow: column wrap;
  }

  button {
    border-radius: 100px;
    cursor: pointer;
    font-size: 1.2rem;
    padding: 0.5rem;
    outline: 0;
    border: 0;
    width: 45%;

    @media all and (max-width: 640px) {
      width: 100%;
      margin: 0.5rem;
    }

    &.button__logout {
      color: #fff;
      background: #00a8e0;
      transition: all 0.2s;

      &:hover {
        background: darken(#00a8e0, 10%);
      }
    }

    &.button__cancel {
      color: #f5f5f5;
      background: #525252;

      &:hover {
        background: darken(#525252, 10%);
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/modals/Logout.vue